import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-slug-onboarding-dialog',
    templateUrl: './slug-onboarding-dialog.component.html',
    styles: [`
    .onboarding-icon { font-size: 48px; color: var(--cf-brand-dark); }
    .example-url { background: #f5f5f5; border-radius: 6px; padding: 8px 12px; font-family: monospace; font-size: 13px; word-break: break-all; }
    .highlight { color: var(--cf-brand-dark); font-weight: bold; }
  `],
    standalone: false
})
export class SlugOnboardingDialogComponent {
  constructor(private dialogRef: MatDialogRef<SlugOnboardingDialogComponent>) { }

  close(): void {
    this.dialogRef.close();
  }
}
